module.exports = __webpack_public_path__ + "static/media/sig--white.184afd62.png";